/**
 * Shared helpers for multi-interval product pricing (one-off / monthly /
 * annual). A product can offer any/all 3 — an empty (0 or missing) price
 * means that interval isn't offered. Used by every shop surface (public
 * Products module, Buy Products agent flow, Basket/Checkout) so the
 * "what's offered" + "how to format it" logic lives in exactly one place.
 */
export const INTERVAL_LABELS = { one_off: "One-off", monthly: "Monthly", annual: "Annual" };
export const INTERVAL_SUFFIX = { one_off: "", monthly: "/mo", annual: "/yr" };
const CURRENCY_SYMBOLS = { GBP: "£", USD: "$", EUR: "€" };

export function symbolFor(currency) {
  return CURRENCY_SYMBOLS[currency] || currency || "";
}

export function getAvailableIntervals(product) {
  const list = [];
  if (Number(product?.price) > 0) list.push("one_off");
  if (Number(product?.price_monthly) > 0) list.push("monthly");
  if (Number(product?.price_annual) > 0) list.push("annual");
  return list;
}

export function defaultInterval(product) {
  return getAvailableIntervals(product)[0] || "one_off";
}

export function priceForInterval(product, interval) {
  if (interval === "monthly") return Number(product?.price_monthly || 0);
  if (interval === "annual") return Number(product?.price_annual || 0);
  return Number(product?.price || 0);
}

export function isFreeProduct(product) {
  return (
    Number(product?.price || 0) <= 0
    && Number(product?.price_monthly || 0) <= 0
    && Number(product?.price_annual || 0) <= 0
  );
}

export function formatIntervalPrice(product, interval, currencyOverride) {
  const currency = currencyOverride || product?.currency || "GBP";
  const symbol = symbolFor(currency);
  const amount = priceForInterval(product, interval).toFixed(2);
  return `${symbol}${amount}${INTERVAL_SUFFIX[interval] || ""}`;
}
